import $ from 'jquery';
import PubSub from 'pubsub-js';
import LazyLoad from "vanilla-lazyload";

import debounce from '../helpers/debounce';
import cropText from '../helpers/cropText';

const queryTypeFilters = [
  {
    label: 'Search',
    slug: 'search',
  },
  {
    label: 'Page',
    slug: 'page',
  },
  {
    label: 'Tag',
    slug: 'tag',
  },
  {
    label: 'Rooms',
    slug: 'rooms',
  },
  {
    label: 'Subcategory',
    slug: 'subcategory',
  }
];

class FilterItem {
  constructor(label, slug, elm, type, group, value) {
    this.label = label;
    this.slug = slug;
    this.elm = elm;
    this.type = type;
    this.group = group;
    this.value = value;

    this.unit;

    this.init();
  }

  init() {
    if (this.type == 'boolean') {

      $(this.elm).on('click', (event) => {
        this.value = !this.value;

        PubSub.publish('BooleanFilterItemChanged', this);
      });

    } else if (this.type == 'select') {
      if (!this.value) {
        this.value = this.elm.value;
      }

      $(this.elm).on('change', event => {
        const { value } = event.currentTarget;

        this.value = value;
        this.label = value;

        PubSub.publish('SelectFilterItemChanged', this);
      })

    } else if (this.type == 'unique') {

      $(this.elm).on('click', (event) => {
        $(this.elm).parent('li').addClass('is-active');
        $(this.elm).parent('li').siblings('li').removeClass('is-active');
        PubSub.publish('UniqueFilterItemChanged', this);
      });

    } else if (this.type == 'range') {
      console.log("FILTER");
      console.log(this);
      this.unit = $(this.elm).data('unit');
      $(this.elm).on('change', (event) => {
        if (event.target.value !== 'initial') {
          this.value = JSON.parse(event.target.value);
          this.label = `from ${this.value.min} ${this.unit} to ${this.value.max} ${this.unit}`;
        } else if ($(event.target).data("filterValueMax")) {
          this.value = {"min": $(event.target).data("filterValueMin"), "max": $(event.target).data("filterValueMax")}
          this.label = `from ${this.value.min} ${this.unit} to ${this.value.max} ${this.unit}`;
        } else {
          this.value = false;
        }

        console.log("THIS STARTER REMOVES THE PARAMETERS");
        PubSub.publish('RangeFilterItemChanged', this);
      });

    }
  }

  _rangeFilterUpdate() {
    if (this.type == 'range') {
      let id = $(this.elm).attr('id');
      let target = $(`.slider[data-target="#${id}"]`);

      target.attr({
        'data-initial-start': this.value.min,
        'data-initial-end': this.value.max
      });
    }
  }

  _rangeFilterReset() {
    if (this.type == 'range') {
      let id = $(this.elm).attr('id');
      let target = $(`.slider[data-target="#${id}"]`);

      let handlers = target.children('.slider-handle');
      let min = $(handlers[0]).attr('aria-valuemin');
      let max = $(handlers[0]).attr('aria-valuemax');

      $(handlers[0]).attr('aria-valuenow', min).css('left', '0%');
      $(handlers[1]).attr('aria-valuenow', max).css('left', '89.9%');

      target.children('.slider-fill').css({
        'min-width': '99.9%',
        'left': '0%',
        'width': '0px'
      });

      $(`#${id}_min`).val(min);
      $(`#${id}_max`).val(max);
    }
  }

  destroy() {
    $(this.elm).off('change click');

    this.label = '';
    this.slug = '';
    this.elm = '';
    this.type = '';
    this.group = '';
    this.value = '';
    this.unit = '';
  }
}

class FilterGroup {
  constructor(name, slug, elm) {
    this.name = name;
    this.slug = slug;
    this.elm = elm;

    this.listeners = [];

    this.init();
  }

  init() {
    let filterItems = $(this.elm).find('*[data-filter-item]');

    filterItems.each((index, filterItem) => {
      let label = filterItem.value;
      let slug = filterItem.name;
      let type;

      let filterItemData = $(filterItem).data('filter-item');
      if (filterItemData == '' || filterItemData == 'boolean') {
        type = 'boolean';
      } else if (filterItemData == 'unique') {
        type = 'unique';
      } else if (filterItemData == 'select') {
        type = 'select';
      } else if (filterItemData == 'range') {
        // to do range
        type = 'range';
      }

      this.listeners.push(new FilterItem(label, slug, filterItem, type, this, false));
    });

  }

  _isDuplicated(recievedValue) {
    let duplicated = false;

    if (this.values.length) {
      this.values.map(item => {
        if (item.slug == recievedValue.slug) {
          duplicated = true;
        }
      });
    }

    return duplicated;
  }

  addFilterItem(values) {
    if (typeof values !== 'object') {
      //throw new Error('Must be an object');
      return;
    }

    if (!this._isDuplicated(values)) {
      this.values.push(values);
    }
  }

  destroy() {
    for (var i = 0; i < this.listeners.length; i++) {
      this.listeners[i].destroy();
    }

    this.name = '';
    this.slug = '';
    this.elm = '';
    this.listeners = [];
  }
}

class ProductFilters {

  constructor(activeFilters = []) {
    this.activeFilters = activeFilters;
    this.initialisedFilters = [];
    this.started = false;

    if (window.ProductFilters) {
      console.warn(`Aborted cause some ProductFilters() is already initialized.`);
    } else {
      this.init();
    }
  }

  init() {

    window.ProductFilters = this;
    this.started = true;

    this.filterGroups = $('*[data-filter-group]');
    this.filterResume = $('*[data-filter-resume]');
    this.filterCleanup = $('*[data-filter-cleanup]');
    this.filterQuery = queryTypeFilters && queryTypeFilters.map(queryFilter => ({
      label: queryFilter.label,
      slug: queryFilter.slug,
      elm: null,
      type: 'query',
      group: new FilterGroup(queryFilter.label, queryFilter.slug, false),
      value: '',
    }));

    this.location = window.location;
    this.hourglass = `<div style="text-align: center;" class="ajax-loader"><span class="loader circle-spin"><img src="/images/ajax-loader.gif" /></span></div>`;

    this._debouncedAjaxCall = debounce(() => {
      $('#product_list').html(this.hourglass);
      let request = this._requestUpdate();
      request.done(data => {
        $('#product_list').html(data).foundation();
        if ($("#filters_menu").hasClass("is-open")) {
          $("#filters_menu").find("button").first().click(); //self closes left menu
        }
        window.setTimeout(() => {
          let myLazyLoad = new LazyLoad({
            elements_selector: ".lazyload"
          });
          // After your content has changed...
          myLazyLoad.update();
          window.listenerDataAction();
        }, 1000);

      })
      .fail(error => {
        console.log(error);
      });

      this._updateFiltersResume();
      this._updateURL();
    }, 0, true);

    this._BooleanFilterItemChanged = PubSub.subscribe('BooleanFilterItemChanged', (msg, filterItem) => {
      // filter updated

      if (filterItem.value) {
        this.addOnActiveFilterList(filterItem);
      } else {
        this.removeFromActiveFilterList(filterItem);
      }
    });

    this._UniqueFilterItemChanged = PubSub.subscribe('UniqueFilterItemChanged', (msg, filterItem) => {
      // filter updated

      let hasActiveSiblings = this._searchActiveFilters(filterItem.group.slug);

      if (hasActiveSiblings.length) {
        let toRemove = $.merge([], hasActiveSiblings);
        for (var i = 0; i < toRemove.length; i++) {
          this.removeFromActiveFilterList(toRemove[i], false);
          filterItem.value = true;
          this.addOnActiveFilterList(filterItem);
          if (i == (toRemove.length - 1)) {
            this._updateView();
          }
        }
      }

      filterItem.value = true;
      this.addOnActiveFilterList(filterItem);
    });

    this._SelectFilterItemChanged = PubSub.subscribe('SelectFilterItemChanged', (msg, filterItem) => {
      let hasActiveSiblings = this._searchActiveFilters(filterItem.group.slug);

      if (hasActiveSiblings.length) {
        let toRemove = $.merge([], hasActiveSiblings);
        for (var i = 0; i < toRemove.length; i++) {
          this.removeFromActiveFilterList(toRemove[i], false);
          if (i == (toRemove.length - 1)) {
            this._updateView();
          }
        }
      }
      this.addOnActiveFilterList(filterItem);
    });

    this._RangeFilterItemChanged = PubSub.subscribe('RangeFilterItemChanged', (msg, filterItem) => {
      console.log(filterItem);
      if (filterItem.value) {
        console.log("1")
        if (this.activeFilters.length) {
          console.log("2");
          let isOnArray = this.activeFilters.some((item) => {
            if (item.slug == filterItem.slug && item.group.slug == filterItem.group.slug) {
              console.log("3")
              return true;
            }
          });

          if (!isOnArray) {
            console.log("4")
            this.activeFilters.push(filterItem);
          } else {
            console.log("5")
            this.activeFilters = this.activeFilters.map(filter => {
              if (filter.slug == filterItem.slug && filter.group.slug == filterItem.group.slug) {
                console.log("6")
                return filterItem;
              } else {
                console.log("7")
                return filter;
              }
            })
          }
        } else {
          console.log("8");
          this.activeFilters.push(filterItem);
        }
        console.log("9");
        this._updateView();
      } else if (filterItem.value == 'initial') {
        console.log("10");
      } else {
        console.log("11");
        this.removeFromActiveFilterList(filterItem);
      }
    });

    $(document).on('changed.zf.slider', event => {
      let handlers = $(event.target).children('.slider-handle');
      let target = $(`${$(event.target).data('target')}`);

      let valueMin = $(handlers[0]).attr('aria-valuenow');
      let valueMax = $(handlers[1]).attr('aria-valuenow');

      let initialMin = $(event.target).data('initial-start');
      let initialMax = $(event.target).data('initial-end');


      if (!$(event.target).is('.slider-loaded')) {
        $(event.target).addClass('slider-loaded');
      }

      if (valueMin != initialMin || valueMax != initialMax) {
        target.val(JSON.stringify({ min: valueMin, max: valueMax }));
      } else {
        target.val('initial');
      }
      target.trigger('change');

    });

    $(document).on('click', '*[data-filter-send]', event => {
      if (this._isMobile()) {
        this._debouncedAjaxCall();
      }
    });

    $(document).on('click', '*[data-filter-item="add"]', event => {
      event.preventDefault();
      let target = $(event.currentTarget);
      let filterItem = this._searchInitialisedFilter(target.data('filter-group'), target.attr('name'));

      if (filterItem) {
        $(filterItem.elm).trigger('click');
      } else {
        console.warn(`This elemment is trying to add some filter not registered yet! This will result no addiction. You should create a [filter-group] element instead of using the [data-filter-item="add"].`);
      }
    });

    $(document).on('click', '*[data-filter-item="reset_group"]', event => {
      event.preventDefault();

      let target = $(event.currentTarget);
      let groupItens = this._searchActiveFilters(target.data('filter-group'));

      let toRemove = $.merge([], groupItens);
      for (var i = 0; i < toRemove.length; i++) {
        this.removeFromActiveFilterList(toRemove[i], false);

        if (i == (toRemove.length - 1)) {
          this._updateView();
        }
      }
    });

    if (this.filterCleanup.length) {
      this.filterCleanup.on('click', '*[data-filter-item]', event => {
        let target = $(event.currentTarget);
        let data = target.data('filter-item');

        if (data == 'remove_all') {
          this.resetActiveFilterList();
        } else if (data == 'reset_group') {
        }
      });
    }

    if (this.filterResume.length) {
      this.filterResume.on('click', '*[data-filter-item]', event => {
        let target = $(event.currentTarget);

        if (target.data('filter-item') == 'remove') {
          let filterItem = this._searchInitialisedFilter(target.data('filter-group'), target.attr('name'));

          if (!filterItem) {
            filterItem = {
              slug: target.attr('name'),
              group: {
                slug: target.data('filter-group')
              }
            }
          }

          this.removeFromActiveFilterList(filterItem);
        }
      });
    }

    if (this.filterQuery.length) {
      for (let i = 0; i < this.filterQuery.length; i++) {
        const filterQuery = this.filterQuery[i];
        const group = new FilterGroup(
          filterQuery.label,
          filterQuery.slug,
          null
        );
        const item = new FilterItem(filterQuery.label, filterQuery.slug, filterQuery.elm, filterQuery.type, filterQuery.group, filterQuery.value);
        group.listeners.push(item);
        this.initialisedFilters.push(group);
      }
    }

    if (this.filterGroups.length) {
      this.filterGroups.each((index, filterGroup) => {
        let filterData = $(filterGroup).data('filter-group');

        if (filterData && filterData.name && filterData.slug) {
          this.initialisedFilters.push(new FilterGroup(filterData.name, filterData.slug, filterGroup));

        } else {
          //console.error(`Your filter group has no name defined, this could create some problem for you if any "somatic" filter were added inside this group.`);
          return;
        }
      });
    }

    if (this.activeFilters.length) {
      this.activeFilters.map(filter => {
        if (filter.type == 'range') {
          let id = $(filter.elm).attr('id');
          let target = $(`.slider[data-target="#${id}"]`);

          let handlers = target.children('.slider-handle');

          $(handlers[0]).attr('aria-valuenow', filter.value.min);
          $(handlers[1]).attr('aria-valuenow', filter.value.max);

          $(`#${id}_min`).val(filter.value.min);
          $(`#${id}_max`).val(filter.value.max);

          $(filter.elm).trigger('change');
        }
      })
    }

    this._getUrlFilters();
    this._updateView(true);

    window.onpopstate = (event) => {
      this._getUrlFilters();
      this._updateView();
    };
  }

  _isMobile() {
    return $('#filter_sidebar').hasClass("has-content");
  }

  _getUrlFilters() {
    this.location.params = window.location.search;
    if (this.location.params) {

      // workaround for "two params" filters to work
      if (this.location.params.indexOf('&type=') > -1) {
        this.location.params = this.location.params.replace('&type=', '_');
      }

      this.location.params.slice(1).split('&').map(param => {
        let values = param.split('=');
        let filter,
          min = false,
          max = false;

        if (values[0].indexOf('min') > -1) {
          values[0] = values[0].replace('_min', '');
          min = values[1];
          filter = this._searchInitialisedFilter(values[0], `${values[0]}_range`);

        } else if (values[0].indexOf('max') > -1) {
          values[0] = values[0].replace('_max', '');
          max = values[1];
          filter = this._searchInitialisedFilter(values[0], `${values[0]}_range`);

        } else if (values[0] == 'products_per_page') {
          filter = new FilterItem(values[1], 'products_per_page', false, 'select', new FilterGroup('Products per Page', 'products_per_page', false), values[1]);

        } else {
          filter = this._searchInitialisedFilter(values[0], values[1]);

        }

        if (filter) {
          if (filter.type == 'boolean') {
            filter.value = true;
            this.addOnActiveFilterList(filter, false);

          } else if (filter.type == 'select') {
            this.addOnActiveFilterList(filter, false);
            let options = $(`select[data-filter-item="select"] > option`);
            let noneFound = true;

            options.each((index, option) => {
              if (option.value == filter.value) {
                $(option).attr('selected', 'selected');
                noneFound = false;
              }
            })

            if (noneFound) {
              $(options).parent('select').append(`<option value="${filter.value}" selected>${filter.value}</option>`);
            }

          } else if (filter.type == 'query') {
            this.addOnActiveFilterList(filter, false);

          } else if (filter.type == 'unique') {
            filter.value = true;
            $(filter.elm).parent().addClass('is-active');
            $(filter.elm).parent('li').siblings('li').removeClass('is-active');

            this.addOnActiveFilterList(filter, false);

          } else if (filter.type == 'range') {
            if (!filter.value) { filter.value = {} }

            if (min) {
              filter.value.min = values[1];
            } else if (max) {
              filter.value.max = values[1];
            }

            if (filter.value.min && filter.value.max) {
              let id = $(filter.elm).attr('id');
              let target = $(`.slider[data-target="#${id}"]`);

              let min = $(target).data('start');
              let max = $(target).data('end');

              if (filter.value.min < min) filter.value.min = min;
              if (filter.value.max > max) filter.value.max = max;

              if (!(filter.value.min == min && filter.value.max == max)) {
                filter.label = `from ${filter.value.min} ${filter.unit} to ${filter.value.max} ${filter.unit}`;
                this.addOnActiveFilterList(filter, false);
                filter._rangeFilterUpdate();
              }
            }
          }
        } else {
          console.warn(`ProductFilters: This param "${values[0]}:${values[1]}"is not a recognized filter.`);
        }
      });
      this._updateView();
    }
  }

  _updateURL() {
    let paramsUpdated = '?';
    this.activeFilters.map(filter => {
      if (paramsUpdated !== '?') { paramsUpdated += '&'; };
      if (filter.type == 'range') {
        paramsUpdated += `${filter.group.slug}_min=${filter.value.min}&${filter.group.slug}_max=${filter.value.max}`;

      } else if (filter.type == 'query') {
        paramsUpdated += `${filter.group.slug}=${filter.value}`;

      } else if (filter.type == 'select') {
        paramsUpdated += `${filter.group.slug}=${filter.value}`;

      } else if (filter.type == 'unique') {
        console.log("is_unique");
        let data = filter.slug.split('_');
        paramsUpdated += `${filter.group.slug}=${data[0]}&type=${data[1]}`;
        // &sort=recent&type=asc // First filter
        // &sort=price&type=asc  // Lower Price
        // &sort=price&type=desc  // Higher Price

      } else {
        paramsUpdated += `${filter.group.slug}=${filter.slug}`;
      }
    });

    if (paramsUpdated == '?') { paramsUpdated = '' };

    if (paramsUpdated !== window.location.search) {
      let url = `${window.location.pathname}${paramsUpdated}`;
      console.log('Filter Update', paramsUpdated, url);
      history.pushState('Filter Update', paramsUpdated, url);
    }
  }

  resetActiveFilterList() {
    // never force cleaning this.activeFilters array, this will cause some outdated states on DOM rendered filter menu
    let toRemove = $.merge([], this.activeFilters);
    for (var i = 0; i < toRemove.length; i++) {
      this.removeFromActiveFilterList(toRemove[i], false);

      if (i == (toRemove.length - 1)) {
        this._updateView();
      }
    }
  }

  addOnActiveFilterList(filterItem, cbUpdateView = true) {
    if (filterItem.type == 'boolean') {
      const buttons = $(`*[data-filter-item][name="${filterItem.slug}"][value="${filterItem.label}"]`);
      if (buttons.length) {
        buttons.addClass('is-active')
      };
    }
    if (filterItem.type == 'unique') {
      $('.c-special-menu__item__title__active').html($('button[name="' + filterItem.slug + '"]').text() + '<span class="select-angle"></span>');
    }
    if (this.activeFilters.length) {
      let isOnArray = this.activeFilters.some((item) => {
        if (item.slug == filterItem.slug && item.group.slug == filterItem.group.slug) {
          return true;
        }
      });

      if (!isOnArray) {
        this.activeFilters.push(filterItem);
      }
    } else {
      this.activeFilters.push(filterItem);
    }

    if (cbUpdateView) {
      this._updateView();
    }
  }

  removeFromActiveFilterList(filterItem, cbUpdateView = true) {
    if (filterItem.type == 'boolean') {
      const buttons = $(`*[data-filter-item][name="${filterItem.slug}"][value="${filterItem.label}"]`);
      if (buttons.length) buttons.removeClass('is-active');
    }

    this.activeFilters = this.activeFilters.filter((item) => {
      if (item.slug == filterItem.slug && item.group.slug == filterItem.group.slug) {
        return;
      } else {
        return item;
      }
    });

    if (filterItem.type == 'range') {
      filterItem._rangeFilterReset();
    }

    if (filterItem.type == 'select') {
      $(`select[data-filter-item="select"] > option`).removeAttr('selected');
      filterItem.value = 24;
    }

    if (cbUpdateView) {
      this._updateView();
    }
  }

  _updateFiltersResume() {
    //shows of hide any "remove all" button
    if (this.filterCleanup.length) {
      if (this.activeFilters.length) {
        this.filterCleanup.fadeIn(400);
      } else {
        this.filterCleanup.fadeOut(400);
      }
    }

    if (this.filterResume.length) {
      this.filterResume.html(this.activeFilters.map(filter => `<li class="c-active-filters__item">
         <div class="grid-x align-justify align-middle">
           <div class="cell shrink">
             <div class="c-active-filters__item__name">${filter.group.name}</div>
             <div class="c-active-filters__item__value">${cropText(filter.label, 25)}</div>
           </div>
           <div class="cell shrink">
             <button class="c-active-filters__item__remove" name="${filter.slug}" value="${filter.label}" data-filter-group="${filter.group.slug}" data-filter-item="remove">
               <i class="icon-close"></i>
             </button>
           </div>
         </div>
       </li>`).join(''));
    }
  }

  _requestUpdate() {
    let filters = '';
    this.activeFilters.map(filter => {
      let thisFilter;
      if (filter.type == 'range') {
        thisFilter = {
          [filter.group.slug]: filter.value,
        }
      } else if (filter.type == 'select') {
        thisFilter = {
          [filter.group.slug]: filter.value
        }
      } else if (filter.type == 'query') {
        thisFilter = {
          [filter.group.slug]: filter.value
        }
      } else if (filter.type == 'unique') {
        let data = filter.slug.split('_');
        thisFilter = {
          [filter.group.slug]: data[0],
          type: data[1]
        }
      } else {
        //treat price like special case
        if (filter.group.slug == 'price') {
          thisFilter = {
            [filter.group.slug]: {
              [filter.slug]: 1
            }
          }
        } else {
          thisFilter = {
            [filter.group.slug]: [filter.slug]
          }
        }
      }

      filters += $.param(thisFilter) + '&';
    });
    filters = filters.slice(0, -1);

    return $.ajax({
      url: '/' + $("html").attr("lang") + '/discover/products/search',
      type: 'GET',
      dataType: 'HTML',
      data: filters
    });
  }

  _updateView(force) {

    // check if te DOM list has some difference based on the array
    let activeCheckboxes = $('*[data-filter-item]:checked');
    if (activeCheckboxes.length !== this.activeFilters.length) {

      if (activeCheckboxes.length) {

        activeCheckboxes.each((index, el) => {
          let existOnArray = this.activeFilters.some(item => {
            return item.slug == el.name;
          });

          if (!existOnArray) {
            el.checked = false;
          } else {
            el.checked = true;
          }
        });

      } else {

        for (var i = 0; i < this.activeFilters.length; i++) {
          $(`*[data-filter-item][name=${this.activeFilters[i].slug}]`).each((index, el) => {
            el.checked = true;
          });
        }
      }
    }

    this._debouncedAjaxCall();

  }

  _searchActiveFilters(groupSlug, itemSlug = false) {
    let filterArray = [];

    this.activeFilters.filter(item => {

      if (item.group.slug == groupSlug) {
        if (itemSlug && item.slug == itemSlug) {
          filterArray.push(item);
        } else {
          filterArray.push(item);
        }
      }
    });

    return filterArray;
  }

  _searchInitialisedFilter(groupSlug, itemSlug = false) {
    let filterItem = false;

    let thisGroup = this.initialisedFilters.filter(group => {
      if (group.slug == groupSlug) {
        if (itemSlug) {
          let thisItem = group.listeners.filter(item => {
            if (item.type == 'query') {
              filterItem = item;
              filterItem.label = itemSlug;
              filterItem.value = itemSlug;
            } else if (item.slug == itemSlug) {
              filterItem = item;
            }
          });
        } else {
          filterItem = group;
        }
      }
    });

    return filterItem;
  }

  destroy(cb) {

    PubSub.unsubscribe(this._BooleanFilterItemChanged);
    PubSub.unsubscribe(this._UniqueFilterItemChanged);
    PubSub.unsubscribe(this._SelectFilterItemChanged);
    PubSub.unsubscribe(this._RangeFilterItemChanged);

    $(document).off('changed.zf.slider');
    $(document).off('click', '*[data-filter-item="add"]');
    $(document).off('click', '*[data-filter-item="reset_group"]');
    $(document).off('click', '*[data-filter-send]');
    this.filterCleanup.off('click', '*[data-filter-item]');
    this.filterResume.off('click', '*[data-filter-item]');

    for (var i = 0; i < this.initialisedFilters.length; i++) {
      this.initialisedFilters[i].destroy()
    }

    this.filterGroups = '';
    this.filterResume = '';
    this.filterCleanup = '';
    this.activeFilters = [];
    this.initialisedFilters = [];

    this.started = false;
    window.ProductFilters = false;

    return cb();
  }
}

export default ProductFilters;
